// extracted by mini-css-extract-plugin
export default {"container":"bq-z","heading":"cq-z","text":"dq-z","info":"eq-z","link":"fq-z","fullMaxWidth":"gq-z"};